export const confirmDiagnosePhone = async (formData, url) => {
  return fetch(`${url}/confirm-phone`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((res) => {
      if (res.status === 500) {
        return {
          error: 'zijn er specifieke vragen of problemen? Stuur een whatsapp op +31 6 38746918'
        }
      }
      return res.json()
    })
    .then((res) => {
      return res
    })
}
